<script setup lang="ts">
import { formatDate, type LocalDate, type Money } from '@taler/domain'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MoneyAmount from '@/app/components/MoneyAmount.vue'

const props = defineProps<{ value: Money; date: LocalDate }>()
const { t, locale } = useI18n()
const formattedDate = computed(() => formatDate(props.date, locale.value as 'en' | 'hu'))
</script>

<template>
  <div
    class="flex flex-col gap-1 rounded-[var(--radius-surface)] border border-[color:var(--color-border)] p-[var(--space-block)] bg-[color:var(--color-surface)]"
  >
    <p class="text-[length:var(--text-step-1)] text-[color:var(--color-text-muted)]">
      {{ t('reporting.netWorthAsOf', { date: formattedDate }) }}
    </p>
    <MoneyAmount :value="value" size="display" />
  </div>
</template>
